import { render } from "./IconCalendar.vue?vue&type=template&id=340c0740"
import script from "./IconCalendar.vue?vue&type=script&lang=ts"
export * from "./IconCalendar.vue?vue&type=script&lang=ts"
script.render = render

export default script